<script setup>
import { useI18n } from 'vue-i18n';

/**
 * SuperTVGo: a aba Relatórios abre o painel da SuperTVGo (funil de lead →
 * pós-teste → cliente, receita e base de contas) embutido aqui dentro, no
 * lugar dos relatórios nativos do Chatwoot — pedido do usuário, 2026-09-20.
 *
 * O painel mora no app da SuperTVGo, não aqui, mas é servido no MESMO domínio
 * (`chat.supertvgo.com/admin/relatorios`, ver o bloco `chat.` do Caddyfile no
 * repo supertvgo). Isso é o que faz o cookie do link secreto valer dentro do
 * iframe: em domínio diferente ele seria cookie de terceiro e o navegador não
 * mandaria. Por isso o `src` é caminho relativo, nunca URL absoluta.
 *
 * Os relatórios nativos continuam existindo nas rotas de sempre
 * (`/app/accounts/:id/reports/...`), só saíram do menu.
 */
const URL_PAINEL = window.SUPERTVGO_RELATORIOS_URL || '/admin/relatorios';

const { t } = useI18n();
</script>

<template>
  <div class="w-full h-full bg-n-surface-1">
    <iframe
      :src="URL_PAINEL"
      :title="t('SIDEBAR.REPORTS')"
      class="w-full h-full border-0"
    />
  </div>
</template>
